class CartDrawerItem extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.id = this.dataset.id;
    this.quantityInput = this.querySelector(".cart-item-quantity-input");

    this.addEventListener("click", (event) => {
      const button = event.target.closest("button");
      if (!button) return;

      if (button.classList.contains("cart-incrementBtn")) {
        this.updateQuantity(parseInt(this.quantityInput.value) + 1);
      } else if (button.classList.contains("cart-decrementBtn")) {
        const value = parseInt(this.quantityInput.value);
        if (value > 1) {
          this.updateQuantity(value - 1);
        }
      } else if (button.classList.contains("cart-drawer-item-remove")) {
        this.updateQuantity(0);
      }
    });
  }

  updateQuantity(quantity) {
    this.dispatchEvent(
      new CustomEvent("cart-item-update", {
        bubbles: true,
        detail: {
          id: this.id,
          quantity: quantity,
        },
      }),
    );
  }
}

if (!customElements.get("cart-drawer-item")) {
  customElements.define("cart-drawer-item", CartDrawerItem);
}
